import { Clickable } from '@carvana/merch-components';
import cx from 'classnames';
import { useContext } from 'react';
import useSendOpenModalEvent, {
  OpenSource
} from 'search/src/components/SearchResults/ResultTileV2/useSendOpenModalEvent';
import MoreDetailsModalSections from 'search/src/constants/MoreDetailsModalSections';
import ModalContext from 'search/src/contexts/ModalContext';
import { useVehicleContext } from 'search/src/contexts/VehicleContext';
import InfoIcon from 'search/src/icons/InfoIcon';
import { usePriceTerms } from '../hooks';

type OwnProps = {
  hasValidTerms: boolean;
};

export default function MonthlyPayment({
  hasValidTerms
}: OwnProps): JSX.Element | null {
  const { vehicle } = useVehicleContext();
  const { monthlyPayment = 0, hasTerms } = usePriceTerms();
  const { setMoreDetailsModalOpen } = useContext(ModalContext);
  const sendOpenEvent = useSendOpenModalEvent();

  const hasValidMonthlyPayment = monthlyPayment > 0;

  return hasTerms ? (
    <div
      className={cx(
        'flex justify-end leading-[20px] monthly-payment text-grey-5 text-right truncate',
        {
          'min-h-[20px]': !hasValidMonthlyPayment
        }
      )}
      data-qa="monthly-payment"
    >
      <div className="pr-4">{!hasValidTerms && 'Est.'}</div>${monthlyPayment}/mo
      <Clickable
        data-analytics-id={null}
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          sendOpenEvent(OpenSource.Terms);
          setMoreDetailsModalOpen(true, {
            openTo: MoreDetailsModalSections.PriceDetails,
            vehicleId: vehicle.vehicleId
          });
        }}
        data-qa="monthly-payment-info"
        className="flex ml-4 self-center"
      >
        <InfoIcon />
      </Clickable>
    </div>
  ) : null;
}
